import { CHANGE_PRIMARY, CHANGE_SECONDARY, CHANGE_URL } from '../actions/actionTypes'

const initState = {
  primary: '#228B22',
  secondary: 'rgba(34,139,34,0.6)',
  url: 'forest url'
}

const colorReducer = (state = initState, action) => {
  switch(action.type) {
    case CHANGE_PRIMARY:
      return { ...state, primary: action.primary };
    case CHANGE_SECONDARY:
      return { ...state, secondary: action.secondary };
      case CHANGE_URL:
        return { ...state, url: action.url };
    default: return state; 
  }
}

export default colorReducer;